import Button, { ButtonEdit } from '../../../UI/Button'
import s from './Header.module.css'
import cn from 'classnames'
import { getAvatar } from '../../../../helpers/getAvatar'
import { useOutside } from '../../../../hooks'
import React, { useEffect, useState } from 'react'
import { Avatar, Image } from 'antd'
import Modal from '@common/Modal'
import { TablePaymentsDiscounts } from '@UI/TablePaymentsDiscounts'
import { IcoRemove } from '@pages/Admin/constsIcon'
import { API } from '@/api'
import { EditIcoNewDesign } from '@/utils/icons'
import { useSelector } from 'react-redux'

const EditHeader = (props) => {
  const isEdit = props.settingCard.editMode && props.settingCard.type === 'edit'
  const [isModalHistory, setIsModalHistory] = useState(false)
  const [items, setItems] = useState([])
  const settings = useSelector((store) => store.settings)
  const isUniversalBalance = settings?.isUniversalBalance === '1'
  const showGamificationExperience =
    props.user.role === 'children'
      ? settings?.isShowGamificationExperienceChild !== '0'
      : settings?.showGamificationExperienceColleagues !== '0'
  const hideTeacherRatingInCard =
    !showGamificationExperience ||
    (props.user.role !== 'children' && settings?.hideTeacherRatingInCard === '1')

  useEffect(() => {
    API.get(`/direction-orders/get-payment-history?id=${props.user.id}`).then(
      (res) => {
        setItems(res.data)
      },
    )
  }, [])

  return (
    <div className={s.header}>
      <AvatarInner {...props} {...{ isEdit }} />
      <div>
        <div className={s.editNameHeader}>
          <h3
            className={cn(s.name, { [s.cursor]: isEdit })}
            onClick={() => isEdit && props.setModal('Name')}
          >
            {props.user.name}
            {props.user.custom_id ? ' (ID: ' + props.user.custom_id + ')' : ''}
          </h3>
          {props.user.role !== 'children' && <Status {...props} />}
          {props.user.status == 0 && <h3 className="text-muted">(удален/a)</h3>}
        </div>

        <div className={s.editRating}>
          {!hideTeacherRatingInCard && (
            <>
              <Star />
              <span style={{ color: 'var(--color-status-danger-text)' }}>0</span>
            </>
          )}

          {isUniversalBalance && (
            <div className={s.balance}>
              Баланс:{' '}
              <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                {props.user.balance + '₽'}
              </span>
              |
              <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                {Number(props.user.balance_euro).toFixed(2) + '€'}
              </span>
              |
              <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                {Number(props.user.balance_dollar).toFixed(2) + '$'}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className={s.editRight}>
        <p className={s.dateRegistration}>
          {props?.user?.createdAt?.dayNumber}{' '}
          {props?.user?.createdAt?.monthGenitive} {props?.user?.createdAt?.year}{' '}
          года
        </p>
        {props.userRole !== 'seminarian' &&
          !props.hideEditMode &&
          !props.settingCard.editMode && (
            <div className={s.editRightActions}>
              <Button
                className={s.editHistoryButton}
                name="История списаний и зачисления"
                onClick={() => setIsModalHistory(true)}
              />
              <ButtonEdit
                className={s.editButton}
                onClick={props.settingCard.setEditMode}
              />
            </div>
          )}
      </div>

      <Modal
        className={s.modal}
        active={isModalHistory}
        setActive={() => setIsModalHistory(false)}
      >
        <IcoRemove
          className={s.modalHistoryIconClose}
          onClick={() => setIsModalHistory(false)}
        />
        <TablePaymentsDiscounts items={items} />
      </Modal>
    </div>
  )
  // });
}

export const Header = (props) => {
  switch (props.settingCard.type) {
    case 'personal':
      return <PersonalHeader {...props} />
    case 'edit':
      return <EditHeader {...props} />
    default:
      return null
  }
}

const PersonalHeader = (props) => {
  if (props.isEmployee) {
    const isNameVisible = props.isTeacherProfileFieldVisible('name')
    const isNameEditable = props.canEditTeacherProfileField('name')

    return (
      <div className={cn(s.header, s.employeePersonalHeader)}>
        {props.hideAvatarChange ? (
          <div className={s.employeeAvatarButton}>
            <AvatarInner {...props} />
          </div>
        ) : (
          <button
            type="button"
            className={s.employeeAvatarButton}
            onClick={() => props.setModal('Ava')}
          >
            <AvatarInner {...props} />
            <span className={s.employeeAvatarEdit}>
              <EditIcoNewDesign />
            </span>
          </button>
        )}
        {isNameVisible && (
          <div className={s.employeePersonalName}>
            <span>{props.user.name}</span>
            {isNameEditable && (
              <button
                type="button"
                className={s.employeeNameEdit}
                onClick={() => props.setModal('Name')}
              >
                <EditIcoNewDesign />
              </button>
            )}
          </div>
        )}
        <div className={s.employeeHeaderActions}>
          <Button
            name={props.saves ? 'Сохранено' : 'Сохранить изменения'}
            styles={cn({ yellow: !props.saves }, { violet: props.saves })}
            className={s.employeeSaveButton}
            action={props.save}
          />
          <span className={cn(s.dateRegistration, s.employeeDateRegistration)}>
            Дата регистрации: {props?.user?.createdAt?.dayNumber}{' '}
            {props?.user?.createdAt?.monthGenitive}{' '}
            {props?.user?.createdAt?.year}
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className={s.header}>
      <AvatarInner {...props} />
      <div className={s.personalButtons}>
        {!props.hideAvatarChange && (
          <Button
            action={() => props.setModal('Ava')}
            className={s.secondaryButton}
          >
            Изменить аватарку
          </Button>
        )}
        {!props?.hidePasswordChange && (
          <Button
            action={() => props.setModal('ChangePassword')}
            className={s.secondaryButton}
          >
            Изменить пароль
          </Button>
        )}
      </div>
      <span className={s.dateRegistration}>
        {props?.user?.createdAt?.dayNumber}{' '}
        {props?.user?.createdAt?.monthGenitive} {props?.user?.createdAt?.year}{' '}
        года
      </span>
    </div>
  )
}

const AvatarInner = (props) => {
  if (props.isEdit)
    return (
      <div
        className={cn('ava', s.ava, {
          [s.cursor]: props.isEdit && !props.hideAvatarChange,
        })}
        onClick={() =>
          props.isEdit && !props.hideAvatarChange && props.setModal('Ava')
        }
      >
        <img src={getAvatar(props.user)} alt="" />
      </div>
    )
  return (
    <Avatar
      className={cn(s.ava, { [s.cursor]: props.isEdit })}
      src={<Image src={getAvatar(props.user)} />}
      size="large"
    />
  )
}

const Status = () => {
  const [ref, isShow, setIsShow] = useOutside(false)
  const [status, setStatus] = React.useState('')
  return (
    <span
      ref={ref}
      className={cn(s.status, s[status])}
      onClick={() => setIsShow(!isShow)}
    >
      <ul className={cn(s.statusList, { [s.show]: isShow })}>
        <li
          onClick={() => setStatus('low')}
          className={cn(s.statusL, s.low)}
        ></li>
        <li
          onClick={() => setStatus('average')}
          className={cn(s.statusL, s.average)}
        ></li>
        <li
          onClick={() => setStatus('high')}
          className={cn(s.statusL, s.high)}
        ></li>
      </ul>
    </span>
  )
}

const Star = () => (
  <svg
    width="26"
    height="25"
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.8996 8.27542L17.0876 7.24771L14.0469 0.847456C13.9024 0.589654 13.6952 0.375702 13.446 0.226986C13.1968 0.07827 12.9143 0 12.6268 0C12.3392 0 12.0567 0.07827 11.8075 0.226986C11.5583 0.375702 11.3511 0.589654 11.2066 0.847456L8.16591 7.24935L1.35393 8.27542C1.06222 8.31881 0.788059 8.44604 0.562496 8.64272C0.336933 8.8394 0.168982 9.09765 0.0776668 9.38823C-0.0136482 9.67881 -0.024678 9.9901 0.0458267 10.2868C0.116331 10.5836 0.265553 10.8539 0.47659 11.0672L5.40451 16.0503L4.24157 23.0872C4.19184 23.3881 4.2243 23.6975 4.33526 23.9803C4.44623 24.2631 4.63127 24.5081 4.86948 24.6876C5.10768 24.867 5.38954 24.9738 5.68319 24.9958C5.97684 25.0177 6.27057 24.9541 6.53116 24.812L12.6268 21.4883L18.7192 24.8087C18.9798 24.9508 19.2735 25.0145 19.5672 24.9925C19.8608 24.9705 20.1427 24.8637 20.3809 24.6843C20.6191 24.5048 20.8041 24.2598 20.9151 23.977C21.0261 23.6942 21.0585 23.3848 21.0088 23.0839L19.8459 16.047L24.7769 11.0672C24.9875 10.8541 25.1363 10.5841 25.2067 10.2879C25.2771 9.99159 25.2662 9.68081 25.1753 9.39062C25.0844 9.10043 24.917 8.84237 24.6922 8.6456C24.4673 8.44883 24.1939 8.32118 23.9028 8.27705L23.8996 8.27542Z"
      fill="#F2C94C"
    />
  </svg>
)
